/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Filter_OfflineInputs */

const vi_fleet_filter_offline = /** @type {(inputs: Fleet_Filter_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

/**

* @param {Fleet_Filter_OfflineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_filter_offline = /** @type {((inputs?: Fleet_Filter_OfflineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Filter_OfflineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_filter_offline(inputs)
});